<template>
  <span class="tooltip-container">
    <span class="tooltip-target">
      <slot />
    </span>
    <div class="tooltip-v">
      <!-- 청체만 툴팁 노출 -->
      <!-- <img v-if="img && upperCd.startsWith('21')" :src="img" @load="onImgLoad" @error="$changeDefaultImage" /> -->
      <img v-if="img" :src="img" @load="onImgLoad" @error="$changeDefaultImage" />
      <span class="text">{{ text }}</span>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: false,
    },
    upperCd: {
      type: String,
      required: false,
    },
  },
  methods: {
    onImgLoad() {
      this.imgLoaded = true;
    },
  },
};
</script>

<style scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
}
/* .tooltip-target {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: center;
} */
.tooltip-target:hover + .tooltip-v {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
}

.tooltip-v {
  display: none;
  color: #ffffff;
  text-align: center;
  padding: 5px 0;
  border-radius: 2px;
  bottom: 100%;
  left: -10%;
  position: absolute;
  z-index: 10;
  background: #333;
  width: 33vw;
  min-width: 250px;
  max-width: 450px;
  border-radius: 5px;
  padding: 5px;
  font-size: 13px;
}

.tooltip-v img {
  width: 65%;
  height: 100%;
  max-width: 100px;
  padding-right: 2px;
}
.text::after {
  content: ' ';
  position: absolute;
  top: 100%;
  left: 30%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
}
.sub-content table tbody tr:nth-child(n + 2):nth-child(-n + 4) .tooltip-container .tooltip-v {
  top: 100%;
  bottom: auto;
}
.sub-content table tbody tr:nth-child(n + 2):nth-child(-n + 4) .text::after {
  top: auto;
  bottom: 100%;
  border-color: transparent transparent #333 transparent;
}
@media all and (max-width: 820px) {
  .tooltip-v img {
    max-width: 15vw;
  }
  .tooltip-v {
    min-width: 60vw;
  }
}
@media all and (max-width: 320px) {
  .tooltip-target:hover + .tooltip-v {
    flex-direction: column;
    flex-wrap: wrap;
  }
  .tooltip-v img {
    max-width: 50vw;
  }
}
</style>
